/*
 * Wondermite product page script (module, loaded by blocks/wm-pdp-head.liquid and sections/wm-under.liquid).
 *   wm-under   "What's under it?": chips swap the close-up on the drawn Scope's screen, the fig. caption and the
 *              note; the new picture zooms in from slightly larger and the focus ring settles. Until someone taps,
 *              the samples step through once while the section is in view. The drawn body takes the color picked
 *              in the buy box (Theme settings > Wondermite > Swatch colors).
 *   price on the Add to cart button follows the picked quantity tier (factory-qty-tiers)
 * Reduced motion, html.factory-lowfx and "motion off": no auto-steps and no zoom, the chips still work.
 */

const root = document.documentElement;
const still = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches || root.classList.contains('factory-lowfx') || !root.classList.contains('wm-anim');

/* ------------------------------------------------------------------ what's under it */
class WmUnder extends HTMLElement {
  connectedCallback() {
    if (this._on) return;
    this._on = true;
    this.chips = [...this.querySelectorAll('.wm-chip[data-u]')];
    this.shots = [...this.querySelectorAll('.wm-dev__shot')];
    this.fig = this.querySelector('[data-u-fig]');
    this.note = this.querySelector('[data-u-note]');
    this.dev = this.querySelector('.wm-dev');
    this.cur = 0;
    this.chips.forEach((chip) =>
      chip.addEventListener('click', () => {
        this.stopAuto();
        this.show(Number(chip.dataset.u));
      })
    );
    this.colors = {};
    (this.dataset.colors || '').split('|').forEach((line) => {
      const i = line.indexOf(':');
      if (i > 0) this.colors[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
    });
    this.paintFromForm();
    this.onChange = () => requestAnimationFrame(() => this.paintFromForm());
    document.addEventListener('change', this.onChange);
    document.addEventListener('variant:update', this.onChange);
    if (this.dataset.auto === 'true' && !still() && 'IntersectionObserver' in window && this.chips.length > 1) {
      this.io = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !this.timer && !this.done) {
            this.timer = setInterval(() => {
              const next = this.cur + 1;
              if (next >= this.chips.length) {
                this.done = true;
                this.stopAuto();
                this.show(0);
                return;
              }
              this.show(next);
            }, 2600);
          } else if (!entry.isIntersecting) this.stopAuto();
        },
        { threshold: 0.5 }
      );
      this.io.observe(this);
    }
  }

  disconnectedCallback() {
    this.stopAuto();
    this.io?.disconnect();
    document.removeEventListener('change', this.onChange);
    document.removeEventListener('variant:update', this.onChange);
    this._on = false;
  }

  stopAuto() {
    clearInterval(this.timer);
    this.timer = 0;
  }

  show(i) {
    if (i === this.cur || !this.shots[i]) return;
    const prev = this.shots[this.cur];
    const next = this.shots[i];
    this.cur = i;
    this.chips.forEach((c, k) => c.setAttribute('aria-pressed', String(k === i)));
    const img = next.querySelector('img');
    if (img && img.loading === 'lazy') img.loading = 'eager';
    prev.classList.remove('is-on');
    next.classList.remove('is-on');
    void next.offsetWidth;
    next.classList.add('is-on');
    this.classList.remove('is-focus');
    void this.offsetWidth;
    this.classList.add('is-focus');
    const chip = this.chips[i];
    const rail = chip.parentElement;
    if (rail && rail.scrollWidth > rail.clientWidth) rail.scrollTo({ left: Math.max(0, chip.offsetLeft - rail.offsetLeft - 24), behavior: still() ? 'auto' : 'smooth' });
    if (this.fig) this.fig.textContent = chip.dataset.fig || '';
    if (this.note) this.note.textContent = chip.dataset.note || '';
  }

  paintFromForm() {
    const opt = (this.dataset.option || 'Color').trim().toLowerCase();
    const picked = [...document.querySelectorAll('input[data-option-name]:checked')].find((i) => (i.dataset.optionName || '').trim().toLowerCase() === opt);
    const color = picked && this.colors[picked.value.trim().toLowerCase()];
    if (color && this.dev) this.dev.style.setProperty('--dev', color);
  }
}
if (!customElements.get('wm-under')) customElements.define('wm-under', WmUnder);

/* ------------------------------------------------------------------ tier price on the Add to cart button */
function tierPrice(scope) {
  const box = scope.querySelector('factory-qty-tiers input[type="radio"]:checked + .factory-tier__box .factory-tier__price');
  if (!box) return '';
  const node = [...box.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
  return node ? node.textContent.trim() : '';
}
function paintAtc(scope) {
  const price = tierPrice(scope);
  scope.querySelectorAll('product-form-component .add-to-cart-button').forEach((btn) => {
    if (btn.disabled) {
      btn.removeAttribute('data-wm-price');
      return;
    }
    if (price) btn.setAttribute('data-wm-price', price);
    else btn.removeAttribute('data-wm-price');
  });
}
function watchAtc() {
  document.querySelectorAll('factory-qty-tiers').forEach((tiers) => {
    const scope = tiers.closest('.shopify-section') || document;
    if (scope.dataset.wmAtc) return;
    scope.dataset.wmAtc = '1';
    paintAtc(scope);
    scope.addEventListener('change', () => requestAnimationFrame(() => paintAtc(scope)));
    new MutationObserver(() => paintAtc(scope)).observe(scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchAtc);
else watchAtc();
